import Reveal, { SectionLabel } from "./Reveal";

const FACTS = [
  "Formada em Medicina — Unigranrio",
  "Pós-graduanda em Neurologia — PUC-Rio",
  "CRM-RJ 0114708-0",
];

export default function Sobre() {
  return (
    <section id="sobre" className="relative bg-olive text-cream py-28 md:py-36 overflow-hidden">
      <span
        className="pointer-events-none absolute -top-10 right-4 md:right-24 font-display text-[22rem] leading-none text-cream/[0.04] select-none"
        aria-hidden="true"
      >
        M
      </span>
      <div className="mx-auto grid max-w-[1240px] gap-16 px-5 md:px-10 lg:grid-cols-[0.9fr_1.1fr] items-start">
        <Reveal className="mx-auto w-full max-w-[440px] space-y-10">
          <div className="rotate-[-2deg] rounded-[24px] border-[6px] border-cream shadow-2xl shadow-olive-deep/60 overflow-hidden aspect-[4/5]" data-testid="sobre-photo-main">
            <img
              src="img/sobre-1.jpg"
              alt="Dra. Mariane Prado sorrindo com a mão no queixo, apoiada em uma cadeira, em seu consultório"
              className="size-full object-cover"
            />
          </div>
          <div className="rotate-[2deg] rounded-[24px] border-[6px] border-cream shadow-2xl shadow-olive-deep/60 overflow-hidden aspect-[4/5]" data-testid="sobre-photo-treinamento">
            <img
              src="img/sobre-3.jpg"
              alt="Dra. Mariane Prado em treinamento prático, marcando pontos em um modelo anatômico"
              className="size-full object-cover object-[center_20%]"
            />
          </div>
        </Reveal>

        <div className="lg:pl-6">
          <SectionLabel n="02" light>
            Sobre
          </SectionLabel>
          <Reveal delay={0.08}>
            <h2 className="mt-8 font-display font-medium text-[clamp(2.4rem,5vw,4.4rem)] leading-[1.02] tracking-[-0.01em]">
              Prazer, <em className="font-serifd italic text-sun">Mariane</em>
            </h2>
          </Reveal>

          <Reveal delay={0.14}>
            <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed text-cream/80 max-w-2xl">
              <p>
                Sou médica, formada em Medicina pela Universidade Unigranrio e pós graduanda em
                Neurologia na Santa Casa da Misericórdia do Rio de Janeiro, pela PUC-Rio.
              </p>
              <p>
                Desde que escolhi a Medicina, sempre tive uma inquietação: entender como o nosso
                corpo funciona, como os diferentes sistemas se conectam e como tudo isso influencia
                quem somos.
              </p>
              <p>
                Foi na Neurologia que encontrei uma parte importante dessas respostas. Descobri a
                complexidade e a beleza de um órgão que participa de praticamente tudo: dos nossos
                movimentos às nossas emoções, da memória à nossa capacidade de interagir com o
                mundo.
              </p>
              <p>
                Mas o que realmente me encantou foi perceber o quanto a Neurologia pode transformar
                a qualidade de vida de uma pessoa.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="mt-9 max-w-2xl font-serifd italic text-xl md:text-2xl leading-relaxed text-sun border-l-2 border-terra pl-6">
              E existe algo que nunca esqueço: antes de ser médica, também sou humana e também sou
              paciente.
            </p>
          </Reveal>

          <Reveal delay={0.24}>
            <div className="mt-9 space-y-5 text-base md:text-lg leading-relaxed text-cream/80 max-w-2xl">
              <p>
                Sei o quanto é importante ser ouvida, acolhida e, principalmente, compreender o que
                está acontecendo com a própria saúde.
              </p>
              <p>
                Por isso, não quero apenas oferecer um diagnóstico ou prescrever um tratamento, por
                trás de cada sintoma existe uma pessoa inteira. Quero que cada paciente saia da
                consulta com respostas, explicadas de forma simples; e, quando elas ainda não forem
                possíveis, com um caminho a seguir.
              </p>
              <p>
                E fiquem tranquilos, não parei e não paro de estudar. Já fiz diversos cursos e
                pretendo continuar trazendo mais e mais conhecimento para dentro do consultório.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.28}>
            <ul className="mt-10 flex flex-wrap gap-3">
              {FACTS.map((f) => (
                <li
                  key={f}
                  className="rounded-full border border-cream/25 px-5 py-2.5 text-sm font-medium tracking-wide text-cream/85"
                >
                  {f}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
